import React from "react";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import HistoryIcon from "@mui/icons-material/History";
import Stack from "@mui/material/Stack";
import ClearStoreData from "./components/ClearStoreData";

const BackToParentAgencyButton = (props) => {
  const { inputId } = props;
  const dispatch = useDispatch();
  const handleClick = () => {
    ClearStoreData({ inputId, dispatch, value: "" });
  };

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <IconButton
        variant="outlined"
        onClick={handleClick}
        disabled={inputId === ""}
        color="secondary"
      >
        <HistoryIcon />
      </IconButton>
    </Stack>
  );
};

export default BackToParentAgencyButton;
